import BillingComponent from '../../components/billing';
import CardWrapper from '../../components/wrapper/card';
import { fetchIntegrationsThunk } from '../../redux/thunks/integration';
import ImageClass from '../../assets';
import { Overlay } from '../../components/prospecting';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

const BillingPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const { selectedClient } = useSelector((state: RootState) => state.client);
  const { integrations, loaders } = useSelector((state: RootState) => state.integration);

  useEffect(() => {
    if (selectedClient?.company_type === 'project' && id) {
      navigate(`/app/client/${id}/dashboard`);
    }
  }, [id]);

  useEffect(() => {
    const fetchIntegraions = async () => {
      try {
        await dispatch(fetchIntegrationsThunk()).unwrap();
      } catch (e) {
        //
      }
    };
    fetchIntegraions();
  }, [dispatch]);

  useEffect(() => {
    const isStripeConnected = integrations.includes('stripe');
    if (isStripeConnected) {
      setIsConnected(true);
    } else {
      setIsConnected(false);
    }
  }, [integrations]);

  if (loaders.isLoading) {
    return <Overlay display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="20px">
      <CircularProgress />
      <Typography variant="body2">Please Wait...</Typography>
    </Overlay>;
  }

  if (!isConnected) {
    return (<Box padding="10px" minHeight="80vh" overflow="auto">
      <CardWrapper>
        <Box display="flex" flexDirection="column" alignItems="center" gap="20px" justifyContent="center" height="70vh">
          <Typography variant="h3" align="center" display="flex" alignItems="center" gap="10px" fontWeight="bold" color="textSecondary">
            Integrate <img src={ImageClass.stripeFullNameLogo} style={{
              marginTop: '5px'
            }} alt="Google Logo" height="40px" /> to sync and view all products and payment details
          </Typography>
          <Button variant="contained" onClick={() => navigate('/app/integrations')}>Navigate to Integrations</Button>
        </Box>
      </CardWrapper>
    </Box>);
  }

  return <BillingComponent />;
};

export default BillingPage;